import api from './api';

export const orderService = {
    getOrders: async (params) => {
        const response = await api.get('/orders', { params });
        return response.data;
    },

    getOrderById: async (orderId) => {
        const response = await api.get(`/orders/${orderId}`);
        return response.data;
    },

    createOrder: async (orderData) => {
        const response = await api.post('/orders', orderData);
        return response.data;
    },

    assignDriver: async (orderId, assignmentData) => {
        const response = await api.post(`/orders/${orderId}/assign`, assignmentData);
        return response.data;
    },

    cancelOrder: async (orderId, cancelData) => {
        const response = await api.post(`/orders/${orderId}/cancel`, cancelData);
        return response.data;
    },

    updateOrder: async (orderId, orderData) => {
        const response = await api.put(`/orders/${orderId}`, orderData);
        return response.data;
    },

    getOrderTracking: async (orderId) => {
        const response = await api.get(`/orders/${orderId}/tracking`);
        return response.data;
    },

    getRecentOrders: async (fleetId, limit) => {
        const params = { limit };
        if (fleetId) params.fleet_id = fleetId;

        const response = await api.get('/orders/recent', { params });
        return response.data;
    },

    getOrdersStats: async (fleetId) => {
        const params = {};
        if (fleetId) params.fleet_id = fleetId;

        const response = await api.get('/orders/stats', { params });
        return response.data;
    },

    enableGlobalDispatch: async (orderId) => {
        const response = await api.post(`/orders/${orderId}/global-dispatch`);
        return response.data;
    }
};